module.exports = { "default": require("core-js/library/fn/object/create"), __esModule: true };


/*****************
 ** WEBPACK FOOTER
 ** ../~/rc-animate/~/babel-runtime/core-js/object/create.js
 ** module id = 1334
 ** module chunks = 3
 **/